@if (isImageLoading) {
  <nimbus-spinner [absolute]="false"></nimbus-spinner>
}
@if (showImage) {
  <img [style.display]="showImage === true ? '' : 'none'" (load)="onLoad()" (error)="onError()" [src]="imageSrc" alt="" />
} @else {
  <span nimbusAvatar [hashBase]="name">
    @if (isIconDisplayed) {
      <i class="avatar-icon" [nimbusIcon]="icon"></i>
    } @else {
      {{ initials }}
    }
  </span>
}
